import axios from "axios";

const api = axios.create({
  headers: { "x-ibm-client-id": process.env.REACT_APP_CLIENT_ID },
  baseURL: process.env.REACT_APP_APIC_HOST,
});

export default api;
